import React from "react";
import styled from "styled-components";

import {
  AdminSection,
  AdminSectionBadge,
  AdminSectionHeader,
} from "../section_engine";


function displayValue(value) {
  if (
    typeof value === "string"
    && value.trim()
  ) {
    return value.trim();
  }

  return "Non renseigné";
}


function displayBoolean(value) {
  return value
    ? "Associé"
    : "Non associé";
}


function formatDate(value) {
  if (
    typeof value !== "string"
    || !value.trim()
  ) {
    return "Non renseigné";
  }

  const normalized =
    value.trim();

  const match =
    normalized.match(
      /^(\d{4})-(\d{2})-(\d{2})$/,
    );

  if (!match) {
    return normalized;
  }

  const [
    ,
    year,
    month,
    day,
  ] = match;

  return `${day}/${month}/${year}`;
}


export default function EmployeeOverviewSection({
  employee,
  user,
  employment,
  organization,
}) {
  return (
    <AdminSection
      aria-labelledby={
        "employee-overview-title"
      }
    >
      <AdminSectionHeader>
        <AdminSectionBadge>
          Overview
        </AdminSectionBadge>

        <h2
          id="employee-overview-title"
        >
          Vue d'ensemble
        </h2>

        <p>
          Synthèse des données Employee
          disponibles en Phase 2.
        </p>
      </AdminSectionHeader>

      <OverviewGrid>
        <OverviewItem>
          <dt>Statut Employee</dt>
          <dd>
            {displayValue(
              employee?.status,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Compte utilisateur</dt>
          <dd>
            {displayBoolean(
              user?.linked,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Email utilisateur</dt>
          <dd>
            {displayValue(
              user?.email,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Type de contrat</dt>
          <dd>
            {displayValue(
              employment?.contract_type,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>État Employment</dt>
          <dd>
            {displayValue(
              employment?.state,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Début Employment</dt>
          <dd>
            {formatDate(
              employment?.start_date,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Fin Employment</dt>
          <dd>
            {formatDate(
              employment?.end_date,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Établissement</dt>
          <dd>
            {displayValue(
              organization
                ?.establishment
                ?.name,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Département</dt>
          <dd>
            {displayValue(
              organization
                ?.department
                ?.name,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Poste</dt>
          <dd>
            {displayValue(
              organization
                ?.position
                ?.name,
            )}
          </dd>
        </OverviewItem>

        <OverviewItem>
          <dt>Manager</dt>
          <dd>
            {displayValue(
              organization
                ?.manager
                ?.name,
            )}
          </dd>
        </OverviewItem>
      </OverviewGrid>
    </AdminSection>
  );
}


const OverviewGrid = styled.dl`
  display: grid;

  grid-template-columns:
    repeat(
      auto-fit,
      minmax(190px, 1fr)
    );

  gap: 0.8rem;

  margin: 0;
`;


const OverviewItem = styled.div`
  min-width: 0;

  padding: 0.75rem;

  border:
    1px solid
    rgba(255, 255, 255, 0.08);

  border-radius: 14px;

  background:
    rgba(11, 19, 40, 0.24);

  dt {
    margin-bottom: 0.35rem;

    color:
      rgba(247, 247, 247, 0.62);

    font-size: 0.76rem;
    font-weight: 700;

    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  dd {
    margin: 0;

    color: #fff9ea;

    font-size: 0.94rem;
    font-weight: 700;

    overflow-wrap: anywhere;
  }
`;
